import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useHistory } from "react-router-dom";
import { auth } from "../firebase/config";
import { sendPasswordResetEmail } from "firebase/auth";

const Login: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [resetSent, setResetSent] = useState(false);
  const { login } = useAuth();
  const history = useHistory();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setResetSent(false);
    const success = await login(email, password);
    if (success) {
      history.push("/editing");
    } else {
      setError("Incorrect email or password");
    }
  };

  const handleResetPassword = async () => {
    try {
      await sendPasswordResetEmail(auth, email);
      setResetSent(true);
      setError("");
    } catch {
      setError("Failed to send reset email. Check your email address.");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f5f6fa",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "Roboto, Arial, sans-serif",
      }}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          background: "#fff",
          borderRadius: "18px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          padding: "32px 24px",
          display: "flex",
          flexDirection: "column",
          gap: "24px",
          minWidth: "320px",
          maxWidth: "90vw",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            color: "#1976d2",
            fontWeight: "bold",
            fontSize: "2rem",
            margin: "0 0 8px 0",
            letterSpacing: "0.5px",
          }}
        >
          Log in
        </h2>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          required
          style={{
            padding: "14px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            fontSize: "1rem",
            outline: "none",
            background: "#f5f6fa",
            transition: "border 0.2s",
          }}
        />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          required
          style={{
            padding: "14px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            fontSize: "1rem",
            outline: "none",
            background: "#f5f6fa",
            transition: "border 0.2s",
          }}
        />
        <button
          type="submit"
          style={{
            background: "#1976d2",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            padding: "14px",
            fontWeight: "bold",
            fontSize: "1.1rem",
            cursor: "pointer",
            boxShadow: "0 2px 8px rgba(25,118,210,0.15)",
            transition: "background 0.2s",
          }}
        >
          Login
        </button>
        {error && (
          <div
            style={{
              color: "#e53935",
              textAlign: "center",
              fontSize: "1rem",
            }}
          >
            {error}
            {email && (
              <button
                type="button"
                onClick={handleResetPassword}
                style={{
                  marginTop: "12px",
                  background: "#fff",
                  color: "#1976d2",
                  border: "1px solid #1976d2",
                  borderRadius: "8px",
                  padding: "10px",
                  fontWeight: "bold",
                  fontSize: "1rem",
                  cursor: "pointer",
                  boxShadow: "0 2px 8px rgba(25,118,210,0.08)",
                  transition: "background 0.2s, color 0.2s",
                  display: "block",
                  width: "100%",
                }}
              >
                Reset password
              </button>
            )}
          </div>
        )}
        {resetSent && (
          <div
            style={{
              color: "#388e3c",
              textAlign: "center",
              fontSize: "1rem",
              marginTop: "8px",
            }}
          >
            Password reset email sent!
          </div>
        )}
      </form>
    </div>
  );
};

export default Login;